import React from 'react';
import styles from './index.module.scss';

interface IStatusRightTitle{
    title: string;
    subtitle: string;
    info?: string;
    id?: string;
}
const StatusRightTitle: React.FC<IStatusRightTitle> = (props) => {
    return (
        <div className={styles.statusContainer} id={props.id}>
            <div>
                <h5 className={styles.title}>-- {props.title} --</h5>
                {props.info !== undefined ? <p className={styles.info}>{props.info} </p>: <></>}
                <h6 className={styles.subtitle}>{props.subtitle}</h6>
            </div>
        </div>
    )
}
export default StatusRightTitle;